import { render, staticRenderFns } from "./RsaAreePianificazioneEditComponent.vue?vue&type=template&id=816b02ae&scoped=true"
import script from "./RsaAreePianificazioneEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaAreePianificazioneEditComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaAreePianificazioneEditComponent.vue?vue&type=style&index=0&id=816b02ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816b02ae",
  null
  
)

/* custom blocks */
import block0 from "./RsaAreePianificazioneEditComponent.vue?vue&type=custom&index=0&blockType=b-col&cols=12&sm=12&md=4&lg=4&xl=4"
if (typeof block0 === 'function') block0(component)

export default component.exports